export default __webpack_public_path__ + "static/media/member-plane.b25dac23.svg";